import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/LandingPage";
import Calculator from "@/Calculator";
import PrivacyPolicy from "@/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#FAFAFA",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/piano-azione" element={<Calculator />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/calcolatore" element={<Navigate to="/piano-azione" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
